// src/components/MapHudButton.tsx
import React from 'react';

interface MapHudButtonProps {
  icon: React.ReactNode;
  label: string; // used for tooltip / accessibility only
  onClick?: () => void;
  className?: string; // to tint per-feature
  active?: boolean; // optional: highlight when toggled
}

const MapHudButton: React.FC<MapHudButtonProps> = ({
  icon,
  label,
  onClick,
  className = '',
  active = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      className={[
        'roddo-pressable roddo-hud-orb relative inline-flex items-center justify-center',
        'h-11 w-11 rounded-[14px] border',
        'bg-[rgba(255,249,239,0.96)] text-[#27364A]',
        'dark:bg-[#101827] dark:text-[#F2F6FC]',
        'border-[#6f573c]/14 dark:border-[rgba(132,151,190,0.18)]',
        'shadow-[0_4px_12px_rgba(89,65,37,0.10)] dark:shadow-[0_4px_12px_rgba(0,0,0,0.18)]',
        'transition-[transform,filter,box-shadow] duration-150 ease-out',
        'hover:-translate-y-[1px] hover:brightness-[1.02] active:translate-y-0 active:scale-[0.97]',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2F80ED]/45 dark:focus-visible:ring-[#67D8E8]/40',
        active
          ? 'ring-2 ring-[#2F80ED]/35 border-[#2F80ED]/30 dark:ring-[#8A70F2]/40 dark:border-[#8A70F2]/36 dark:bg-[#151F31]'
          : '',
        className,
      ].join(' ')}
    >
      <span className="relative z-10 flex items-center justify-center text-lg text-current">
        {icon}
      </span>

    </button>
  );
};

export default MapHudButton;
